import { createSelector } from 'reselect';
import { toJS } from 'utils/immutable';
import { formatProjectMetadataDates } from 'utils/projectMetadata/formatProjectMetadataDates';
import * as Models from './models';

export const rootDocument = (state): Models.State.IState => state.get('rootDocument');
export const documentMetadata = createSelector(
  [rootDocument],
  rootDoc => formatProjectMetadataDates(toJS(rootDoc)),
);
export const rootDocumentId = (state): number => rootDocument(state).get('documentId');
export const targetLanguage = (state): string[] => rootDocument(state).get('language') as unknown as string[];
export const targetCountry = (state): string[] => rootDocument(state).get('country') as unknown as string[];
export const targetProduct = (state): string[] => rootDocument(state).get('product') as unknown as string[];
export const subtypeProduct = (state): string => rootDocument(state).get('subtype');
